import { Data } from '@blade/std-lib'

// Strict match type means the hostname must be exactly the same as the value
export class StrictMatchType extends Data.TaggedClass('StrictMatchType')<{
  value: string
}> {}

export type KnownSocialPlatformMatchType =
  // string: domain + subdomain
  string | StrictMatchType
